import { USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY } from "../axios/constants";
import { clear, get, set } from "./local-storage";

export const setOnLocalStorage = (location) => set(USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY, location);
export const getFromLocalStorage = () => get(USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY);
export const clearOnLocalStorage = () => clear(USER_SELECTED_LOCATION_LOCAL_STORAGE_KEY);